<div class="w-full">
  <div class="flex w-full max-w-[1200px] mx-auto  sm:py-[80px] py-0 flex-col items-start ">
    <div class="flex flex-col items-start gap-12 self-stretch">
      <div class="flex flex-col  sm:gap-5 px-[24px] py-[32px] items-start gap-[16px] self-stretch">
        <span
          class="text-[#00B884] text-center font-[Manrope] text-[16px] not-italic font-medium leading-[17px] tracking-[1px] uppercase">
          {{'BENEFIT' | translate}}
        </span>
        <h2
          class="self-stretch text-[#1B1B1B] font-[Manrope] text-[45px] not-italic font-bold leading-[58px] tracking-[-0.9px]">
          {{'Why to choose Income Protection Insurance provided by ' | translate}} <span
            class="text-[#F5375C] font-[Manrope] ">{{'PVI' | translate}}</span>
        </h2>
        <p
          class="self-stretch text-[#1B1B1B] font-[Manrope] text-[20px] not-italic font-normal leading-[140%] tracking-[-0.4px]">
          {{'Comprehensive financial safety net for all workers. With affordable premiums and high protection benefits, it helps you stay secure and confident against life’s uncertainties.' | translate}}
        </p>
        <span class="w-[100px] h-[5px] rounded-[5px] bg-[#FD71AF] block"></span>
        <div class="grid justify-center gap-9  py-[80px]">
          <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-6">
          <div *ngFor="let item of items" class="p-[1px] h-[310px] rounded-[2rem_0_0_0] bg-gradient-to-b from-[#f53773] to-white lg:h-[400px]">
            <div class="bg-white rounded-[2rem_0_0_0] p-6 flex flex-col gap-4 h-full">
              <span class="text-[#1B1B1B] font-[Manrope] font-extrabold text-[14px] sm:text-[20px] leading-[140%]">
                {{ item.title | translate }}
              </span>
          
              <img [src]="item.img" alt="card image"
                class="w-[150px] h-[150px] sm:w-[300px] sm:h-[300px] object-contain mx-auto" />
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div  id="premium-cal" class="flex w-full h-full lg:h-[600px] overflow-hidden pt-[60px] flex-col items-center bg-[#F5375C]">
      <app-asahi-premium-cal></app-asahi-premium-cal>
    </div> -->
  
  </div>
</div>

<div class="bg-[#FFF2F6] w-full">
  <div class="flex w-full max-w-[1200px] mx-auto  py-0 flex-col items-start ">
    <div id="leads-form" class="flex flex-col items-start gap-12 self-stretch ">
      <div
        class="flex flex-col sm:gap-5 px-[24px] py-[32px]  lg:py-[112px] items-start gap-[16px] self-stretch">
        <div
          class="flex flex-col w-full sm:w-full sm:p-[48px_60px] p-[32px_24px_16px_24px] sm:gap-[60px] gap-[24px] justify-center items-start self-stretch rounded-[48px] border border-[#D9D9D9] bg-[#FFF] shadow-[0_4px_80px_0_rgba(0,0,0,0.08)]">
          <div class="flex flex-col w-full justify-center items-start gap-[10px]">
            <span
              class="text-[#00B884] text-center font-[Manrope] text-[16px] not-italic font-medium leading-[17px] tracking-[1px] uppercase">
              {{'REGISTER FOR CONSULTANT' | translate}}
            </span>
            <h2 class="self-stretch text-[#F5375C] font-[Manrope] 
              text-[24px] sm:text-[45px] 
              not-italic font-extrabold 
              leading-[120%] 
              tracking-[-0.96px] sm:tracking-[-0.9px]">
              {{'Secure your future against life’s unpredictable risks' | translate}}
            </h2>
            <p class="self-stretch font-[Manrope] 
              text-[12px] sm:text-[22px] 
              font-medium 
              not-italic 
              leading-normal 
              text-[rgba(27,27,27,0.80)] sm:text-[#121212] 
              tracking-[-0.24px] sm:tracking-normal">
              {{'Complete your details to receive consultation on the right protection plan for your financial security against income
              loss from accidents or unexpected health issues.'| translate}}
            </p>
            <span class="block w-[90%] h-[1.669px] bg-[#D9DBE9]"></span>
          </div>
          <div class="flex flex-col gap-8 self-stretch">
            <form [formGroup]="form">
              <!-- Wrapper -->
              <div class="flex flex-col md:flex-row items-start gap-[20px]  mb-[20px] sm:mb-[38px] md:gap-[38px] self-stretch mb-[38px]">
                <!-- Name Input -->
                <div class="flex-1 w-full flex flex-col">
                  <input type="text" formControlName="name" placeholder="{{'What is your name?' | translate}}"
                    class="w-full h-[64.577px] px-[30.492px] py-[22.869px] rounded-[50px] border-[1.906px] border-[rgba(117,125,138,0.32)]" />
                  <div class="h-[20px]"> <!-- reserve space for error -->
                    @if (form.get('name')?.invalid && (form.get('name')?.touched || form.get('name')?.dirty)) {
                    <div class="text-[#F03457] text-sm">
                      @if (form.get('name')?.errors?.['required']) {
                      <span class="ml-2">{{'Name is required.' | translate}}</span>
                      }
                    </div>
                    }
                  </div>
                </div>

                <!-- Phone Input -->
                <div class="flex-1 w-full flex flex-col">
                  <input #phoneInput id="mobileNo" formControlName="mobileNo" type="text" (input)="formatPhone($event)"
                    placeholder="{{ 'What is your phone number?' | translate }}"
                    class="w-full h-[64.577px] px-[30.492px] py-[22.869px] rounded-[50px] border-[1.906px] border-[rgba(117,125,138,0.32)]" />
                  <div class="h-[20px]">
                    <!-- Error messages -->
                    <ng-container
                      *ngIf="form.get('mobileNo')?.invalid && (form.get('mobileNo')?.touched || form.get('mobileNo')?.dirty)">
                      <div class="text-[#F03457] text-sm">
                        <ng-container *ngIf="form.get('mobileNo')?.errors?.['required']">
                          <span class="ml-2">{{ 'Phone number is required.' | translate }}</span>
                        </ng-container>
                        <ng-container *ngIf="form.get('mobileNo')?.errors?.['pattern'] || form.get('mobileNo')?.errors?.['invalidPhone']">
                          <span>{{ 'Please enter a valid 10-digit phone number.' | translate }}</span>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <!-- year + Birth -->
              <div class="flex flex-col md:flex-row items-start gap-[20px] md:gap-[38px] self-stretch mb-[38px]">
                <!-- Gender -->
                <div class="dropdown-container flex-1 w-full flex flex-col">
                  <div class="relative w-full">
                    <div
                      class="w-full h-[64.577px] px-[30.492px] py-[22.869px] rounded-[50px] border-[1.906px] border-[rgba(117,125,138,0.32)] text-[#757D8A] appearance-none"
                      (click)="toggleDropdown('gender')">
                      <input formControlName="gender" [value]="(selectedGender || '') | translate" readonly
                        placeholder="{{ 'What is your gender?' | translate }}" class="w-full outline-none text-black" />
                    </div>
                    <!-- Dropdown -->
                    <div *ngIf="activeDropdown === 'gender'"
                      class="z-10 absolute bg-white shadow-lg mt-2 border border-[#232124] rounded-xl w-full">
                      <div *ngFor="let gen of gender" (click)="selectGender(gen); closeDropdown()"
                        class="px-4 py-2 rounded-xl cursor-pointer"
                        [ngClass]="gen === selectedGender ? 'text-[#F03457] font-semibold' : 'text-black'">
                        {{ gen | translate }}
                      </div>
                    </div>
                    <!-- Custom arrow -->
                    <svg
                      class="pointer-events-none absolute right-[20px] top-1/2 -translate-y-1/2 w-[24px] h-[24px] text-[#757D8A]"
                      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                  <!-- Error space reserved -->
                  <div class="h-[20px]">
                    @if (form.get('gender')?.invalid && (form.get('gender')?.touched || form.get('gender')?.dirty)) {
                    <div class="text-[#F03457] text-sm">
                      @if (form.get('gender')?.errors?.['required']) {
                      <span class="ml-2">{{ 'Gender is required.' | translate }}</span>
                      }
                    </div>
                    }
                  </div>
                </div>

                <!-- Birth Select -->
                <div class=" flex-1 w-full flex flex-col">
                  <div class="relative w-full" (click)="toggleDropdown('calender')">
                  <app-calendar-picker [active]="activeDropdown" [asahi]="true"
                    [placeholder]="'What is your year of birth?' | translate" [showIcon]="true"
                    (closeActive)="closeDropdown()" (dateSelected)="onDateSelected($event)">
                  </app-calendar-picker>
                  </div>
                  <!-- Error space reserved -->
                  <div class="h-[20px]">
                    @if (form.get('yearOfBirth')?.invalid && (form.get('yearOfBirth')?.touched ||
                    form.get('yearOfBirth')?.dirty)) {
                    <div class="text-[#F03457] text-sm">
                      @if (form.get('yearOfBirth')?.errors?.['required']) {
                      <span class="ml-2">{{ 'Birth Year is required.' | translate }}</span>
                      }

                    </div>
                    }
                    @if (form.get('yearOfBirth')?.errors?.['invalidYear']) {
                    <div class="text-[#F03457] text-sm">
                      <span class="ml-2">{{ 'Future dates are not allowed for Date of Birth' | translate }}</span>
                    </div>
                    }
                  </div>
                </div>
              </div>

              <!--income & occupation-->
              <div class="flex flex-col mb-[20px]  sm:mb-[38px] gap-[20px] md:flex-row items-start self-stretch ">
                <!-- Income -->
               <div class="dropdown-container flex-1 w-full flex flex-col">
  <div class="relative w-full">
    <!-- Wrapper div with flex for alignment -->
    <div
      class="flex items-center justify-between w-full h-[64px] px-[24px] rounded-[50px] border border-[rgba(117,125,138,0.32)] bg-transparent cursor-pointer"
      (click)="toggleDropdown('income')"
    >
      <!-- Input -->
      <input
        formControlName="averageMonthlyIncome"
        [value]="(selectedIncome || '') | translate"
        readonly
        placeholder="{{ 'Which range is your monthly average income?' | translate }}"
        class="flex-1 bg-transparent outline-none text-black placeholder:text-[#757D8A] text-[16px]"
      />

      <!-- Arrow icon -->
      <svg
        class="w-[22px] h-[22px] text-[#757D8A] shrink-0 ml-2"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </div>

    <!-- Dropdown -->
    <div
      *ngIf="activeDropdown === 'income'"
      class="z-10 absolute bg-white shadow-lg mt-2 border border-[#232124] rounded-xl w-full max-h-[200px] overflow-y-auto"
    >
      <div
        *ngFor="let item of income"
        (click)="selectIncome(item); closeDropdown()"
        class="px-4 py-2 rounded-xl cursor-pointer hover:bg-gray-100"
        [ngClass]="item === selectedIncome ? 'text-[#F03457] font-semibold' : 'text-black'"
      >
        {{ item | translate }}
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <div class="h-[20px] mt-1">
    @if (form.get('averageMonthlyIncome')?.invalid && (form.get('averageMonthlyIncome')?.touched ||
    form.get('averageMonthlyIncome')?.dirty)) {
    <div class="text-[#F03457] text-sm">
      @if (form.get('averageMonthlyIncome')?.errors?.['required']) {
      <span class="ml-2">{{ 'Income is required.' | translate }}</span>
      }
    </div>
    }
  </div>
</div>


                <!-- Occupation -->
             <div class="dropdown-container flex-1 w-full flex flex-col">
  <div class="relative w-full">
    <!-- Wrapper with flex for alignment -->
    <div
      class="flex items-center justify-between w-full h-[64px] px-[24px] rounded-[50px] border border-[rgba(117,125,138,0.32)] bg-transparent cursor-pointer"
      (click)="toggleDropdown('Occupation')"
    >
      <!-- Input -->
      <input
        formControlName="occupation"
        [value]="(selectedOcuupation || '') | translate"
        readonly
        placeholder="{{ 'What is your current occupation?' | translate }}"
        class="flex-1 bg-transparent outline-none text-black placeholder:text-[#757D8A] text-[16px]"
      />

      <!-- Dropdown icon -->
      <svg
        class="w-[22px] h-[22px] text-[#757D8A] shrink-0 ml-2"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </div>

    <!-- Dropdown menu -->
    <div
      *ngIf="activeDropdown === 'Occupation'"
      class="z-10 absolute bg-white shadow-lg mt-2 border border-[#232124] rounded-xl w-full max-h-[200px] overflow-y-auto"
    >
      <div
        *ngFor="let item of occupation"
        (click)="selectOcuupation(item); closeDropdown()"
        class="px-4 py-2 rounded-xl cursor-pointer hover:bg-gray-100"
        [ngClass]="item === selectedOcuupation ? 'text-[#F03457] font-semibold' : 'text-black'"
      >
        {{ item | translate }}
      </div>
    </div>
  </div>

  <!-- Validation message -->
  <div class="h-[20px] mt-1">
    @if (form.get('occupation')?.invalid && (form.get('occupation')?.touched || form.get('occupation')?.dirty)) {
    <div class="text-[#F03457] text-sm">
      @if (form.get('occupation')?.errors?.['required']) {
      <span class="ml-2">{{ 'Occupation is required.' | translate }}</span>
      }
    </div>
    }
  </div>
</div>

              </div>

              <!--insurance-->
           <div class="relative w-full mb-[20px] sm:mb-[38px]">
  <div
    class="w-full h-[64.577px] px-[30.492px] rounded-[50px] border-[1.906px] 
           border-[rgba(117,125,138,0.32)] bg-transparent text-[#757D8A] 
           flex items-center text-[15px] leading-none"
  >
    <span class="whitespace-normal sm:whitespace-nowrap">
      {{ 'Who do you want to buy insurance for?' | translate }}
    </span>
  </div>
</div>

              <div class="flex flex-col gap-2 mb-[20px] w-full sm:mb-[38px]">
                <div class="flex flex-wrap gap-4 sm:gap-8">
                  <div class="flex items-center gap-2 relative flex-1 min-w-[150px] sm:min-w-[180px]"
                    *ngFor="let opt of ['SELF','FAMILY','FRIENDS','OTHERS']">

                    <input type="checkbox" [value]="opt" [checked]="form.get('insuranceFor')?.value.includes(opt)"
                      (change)="onCheckboxChange($event, opt)" class="peer bg-white checked:bg-[#F03457] border-[#3C3C3C99] border-2 rounded 
                                          focus:outline-none w-[28px] h-[28px] appearance-none" />

                    <span class="top-0 left-0 absolute flex justify-center items-center 
                                              bg-[#F03457] opacity-0 peer-checked:opacity-100 rounded w-[28px] h-[28px] 
                                              transition-opacity pointer-events-none">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M5 10.5L9 14.20L15 7.5" stroke="white" stroke-width="4" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </span>

                    <label class="text-gray-700">
                      {{ opt === 'SELF' ? ('For myself' | translate) :
                      opt === 'FAMILY' ? ('For my family' | translate) :
                      opt === 'FRIENDS' ? ('For my friends' | translate) :
                      ('Other' | translate) }}
                    </label>
                  </div>
                </div>
                <!-- Error space reserved -->
                <div class="h-[20px]">
                  @if (form.get('insuranceFor')?.invalid || (form.get('insuranceFor')?.touched  && !form.get('insuranceFor')?.value.length ||
                  form.get('insuranceFor')?.dirty))
                  {
                  <div class="text-[#F03457] text-sm">
                    <!-- @if (form.get('insuranceFor')?.errors?.['required']) { -->
                    <span class="ml-2">{{ 'InsuranceFor is required.' | translate }}</span>
                    <!-- } -->
                  </div>
                  }
                </div>
              </div>
              <!-- Conditional dropdown (only once, outside loop) -->
              <div *ngIf="showInsuranceForOthers" class="dropdown-container relative w-full  mb-[20px] sm:mb-[38px]">
                <div (click)="toggleDropdown('insuranceFor')" class="w-full h-[64.577px] px-[30.492px] py-[22.869px] rounded-[50px] 
                        border-[1.906px] border-[rgba(117,125,138,0.32)] 
                        text-[#757D8A] appearance-none" (click)="toggleAgeDropdown()">
                  <input formControlName="beneficiaryAgeRange" [value]="selectedAge" readonly
                    placeholder="{{ 'What is the age range of whom you want to buy insurance for?' | translate }}"
                    class="w-full outline-none text-black" />
                </div>
                <!-- Dropdown -->
                <div *ngIf="activeDropdown === 'insuranceFor'"
                  class="z-10 absolute bg-white shadow-lg mt-2 border border-[#232124] h-[200px] overflow-scroll rounded-xl w-full">
                  <div *ngFor="let item of age" (click)="selectAge(item); closeDropdown()" class="px-4 py-2 rounded-xl cursor-pointer"
                    [ngClass]="item === selectedAge ? 'text-[#F03457] font-semibold' : 'text-black'">
                    {{ item | translate}}
                  </div>
                </div>
                <!-- Custom arrow -->
                <svg class="pointer-events-none absolute right-[20px] top-1/2 -translate-y-1/2 
                          w-[24px] h-[24px] text-[#757D8A]" xmlns="http://www.w3.org/2000/svg" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <!-- Consent -->
              <div class="flex items-start mb-[20px] sm:mb-[38px]">
                <!-- Checkbox -->
                <div>
                  <label class="inline-block relative align-middle">
                    <input id="consent" type="checkbox" formControlName="consent"
                      class="peer bg-white checked:bg-[#F03457] border-[#3C3C3C99] border-2 rounded focus:outline-none w-[28px] h-[28px] appearance-none" />
                    <span
                      class="top-0 left-0 absolute flex justify-center items-center bg-[#F03457] opacity-0 peer-checked:opacity-100 rounded w-[28px] h-[28px] transition-opacity pointer-events-none">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 10.5L9 14.20L15 7.5" stroke="white" stroke-width="4" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </span>
                  </label>
                </div>

                <!-- Text -->
                <div class="ml-3 font-primary flex-1">
                  <label for="consent" class="font-primary text-[#958D90]">
                    {{'I agree that LivWell may collect, provide, and share all information I have submitted in this form with Asahi, so that
                    Asahi may contact me to provide consultation and offer the Income Protection insurance co-provided by Asahi and PVI. In
                    return, Asahi will update LivWell with the contact status for reconciliation purposes between the parties.'|
                    translate}}
                  </label>
                  @if (form.get('consent')?.invalid && (form.get('consent')?.touched || form.get('consent')?.dirty)) {
                  <div class="mt-2 text-[#F03457]">
                    <span>{{ 'You must consent to the terms and conditions to proceed.' | translate }}</span>
                  </div>
                  }
                </div>
              </div>
              <!-- Submit Button -->
          <button type="button" (click)="onSubmit()" [disabled]="isLoading"
            class="flex font-[manrope] w-full px-[20px] py-[12px] justify-center items-center gap-[8.986px] font-extrabold self-stretch rounded-[89.857px] bg-[#2AD189] text-[20px] transition-colors duration-300 hover:bg-[#A4FFD6]">
            <span *ngIf="!isLoading">{{ 'SUBMIT' | translate }}</span>
            <span *ngIf="isLoading" class="flex items-center gap-2">
              <svg class="animate-spin h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
              </svg>
                                      {{'Loading...' | translate}}
            </span>
          </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--OTP-->
<app-asahi-otp-modal [asahi]="false" [visible]="showOtpModal" [phoneMasked]="otpPhoneMasked" [countryCode]="otpCountryCode"
  [mobileNo]="otpMobileNo" [errorMsg]="otpErrorMsg" [loading]="otpLoading"  (resendOtp)="onVerifyPhone()" (verified)="onOtpVerified($event)"
  (closed)="onOtpClosed()" (edit)="onOtpEdit()" (zaloVerify)="onOtpZaloVerify()"
  (callVerify)="onOtpCallVerify()"></app-asahi-otp-modal>